export const API_URLS = {
    media: '/api/search/listingfilter',
    search: '/api/search/searchfilter',
    typeahead: '/api/search/typeaheadsearch',
    COMPLAINT: '/api/form/complaint'
};
